import { ELECTRON_EVENTS } from '~/main/namespace';
import { isClientSideReady } from '~/renderer/utils';

import type { AnyAction, Dispatch, Middleware } from '@reduxjs/toolkit';
import type { AppState } from '~/renderer/store/types';

export const forwardToRenderer: Middleware<AnyAction, AppState> =
  () => (next: Dispatch) => async (action: AnyAction) => {
    if (isClientSideReady()) {
      return next(action);
    }

    if (action?.meta?.scope === 'local') return next(action);

    // change scope to avoid endless-loop
    const rendererAction: AnyAction = {
      ...action,
      meta: {
        ...action.meta,
        scope: 'local',
      },
    };

    const electron = await import('electron');
    const allWebContents: Electron.WebContents[] = electron.webContents.getAllWebContents();

    const mapEventsToContent: { [key: string]: string } = {
      'receipt/': 'cfd',
      'printers/': 'hub',
    };

    allWebContents.forEach(contents => {
      // Prevent sending events to chrome-extension
      const url = contents.getURL();
      if (url.startsWith('chrome-extension://')) return;

      // Filter broadcasted events by section (electron window)
      const section = action.type
        ? Object.entries(mapEventsToContent).find(([prefix]) => action.type.startsWith(prefix))?.[1]
        : null;

      if (!section || url.includes(section)) {
        contents.send(ELECTRON_EVENTS.REDUX_ACTION, rendererAction);
      }
    });

    return next(action);
  };
